<template>
  <div
    style="position:relative;"
    v-if="adv">
    <div
      v-if="adv.status==='canceled' || !plan.adv_enabled || !adv.promoteur.plan.adv_enabled"
      class="frontdrop"></div>
    <div class="is-border-top is-border-right is-border-left">
      <div
        v-if="!isComplete"
        class="notification is-danger has-text-centered is-marginless">
        <p class="is-uppercase is-size-7">
          <span class="icon"><i class="fas fa-exclamation-circle"></i></span>
          <span class="has-text-weight-medium">INFORMATIONS ET fichiers MANQUANTS : </span> impossible de générer le
          dossier de réservation
        </p>
      </div>
      <div
        v-if="!isComplete"
        class="is-margin-bottom-small notification is-warning is-marginless is-min-height-75 is-flex">
        <div class="is-self-centered w100 is-uppercase is-size-7 has-text-weight-medium">
          Vous devez vérifier et/ou completer les informations manqantes.<br>
          Les informations manquantes sont précédées de cette icone
          <span class="icon is-small has-text-danger"><i class="fas fa-check-circle"></i></span>
          dans les rubriques suivantes
        </div>
      </div>
      <div
        v-if="isComplete && adv.reservation_contract"
        class="is-margin-bottom-small notification is-success has-text-centered is-marginless">
        <p class="is-uppercase is-size-7">
          <span class="icon"><i class="fas fa-check-square"></i></span>
          <span class="has-text-weight-medium">DOSSIER COMPLET : </span> vous pouvez visualiser le dossier de
          réservation
        </p>
      </div>
      <div
        v-if="contractName"
        class="columns is-gapless is-marginless has-background-white is-minH64p is-border-top">
        <div class="column columns is-self-centered is-padding-left">
          <div
            class="column is-narrow is-flex is-padding-small is-margin-right-large is-margin-left-large">
            <span
              class="icon is-self-centered">
              <i class="fa-3x fal fa-folder-open"></i>
            </span>
          </div>
          <div
            class="is-margin-left-large column is-padding-left-small is-self-centered columns is-gapless is-vcentered is-marginless">
            <span class="is-5 has-text-weight-bold is-padding-right-xsmall is-uppercase">
              Modèle:
            </span>
            <span class="is-5 is-padding-left">
              {{ contractName }}
            </span>
          </div>
        </div>
        <div
          v-if="isAdmin && isPromoteur"
          class="column is-self-centered  is-4 is-narrow is-padding-right-xsmall">
          <a
            @click="openPreviewContractSelect"
            class="button is-light is-border is-small is-uppercase is-fullwidth is-radius is-minH50p">
            <span>Changer le modèle de contrat</span>
          </a>
        </div>
      </div>
      <div class="columns is-centered is-4 is-gapless has-background-white is-border-top">
        <div class="column is-flex is-narrow is-padding-top is-padding-left is-padding-bottom">
          <div class="has-vadBadge--topright has-vadBadge--out-quarter">
            <i class="fal fa-6x fa-file-pdf"></i>
            <span
              v-if="!isComplete"
              class="vadBadge is-large is-bordered is-danger tooltip is-tooltip-top"
              data-tooltip="Information manquante">
              <span class="icon"><i class="fas fa-exclamation"></i></span>
            </span>
            <span
              v-else-if="isComplete && adv.reservation_contract"
              class="vadBadge is-large is-bordered is-success tooltip is-tooltip-top"
              data-tooltip="Dossier complet">
              <span class="icon"><i class="fas fa-check"></i></span>
            </span>
          </div>
        </div>
        <div class="column is-self-centered is-narrow is-padding-top is-padding-left is-padding-bottom">
          <div>
            <span
              class="title is-3"
              style="font-weight: 500;">Contrat de réservation ADV {{ adv.ref }}</span>
          </div>
          <div class="column is-narrow is-padding-top-small is-paddingless-left is-paddingless-bottom is-padding-right-xlarge is-margin-right-xlarge">
            <a
              v-if="!isComplete"
              :disabled="true"
              class="button is-small is-light is-border is-transform-none is-fullwidth is-radius">
              <span class="">Visualisation impossible</span>
            </a>
            <a
              v-else-if="isComplete && adv.signed_contract"
              @click="openPreview(adv.signed_contract)"
              class="button is-small is-light is-border is-transform-none is-fullwidth is-radius">
              <span class="">Voir le contrat signé</span>
            </a>
            <div
              v-else-if="isComplete && adv.reservation_contract"
              class="is-flex is-align-items-center">
              <a
                @click="openPreview(adv.reservation_contract)"
                class="button is-small is-light is-border is-transform-none is-fullwidth is-radius">
                <span class="">Voir le contrat</span>
              </a>
              <div class="is-margin-left-xsmall">
                <button
                  @click="reloadContract"
                  class="button is-small is-light is-border is-transform-none is-radius tooltip is-tooltip-right"
                  data-tooltip="Régénérer le contrat">
                  <i class="fas fa-redo"></i>
                </button>
                <!-- <span class="tooltip-text">Régénérer le contrat</span> -->
              </div>
            </div>
            <a
              v-else
              :disabled="true"
              class="button is-small is-light is-border is-transform-none is-fullwidth is-radius">
              <img
                style="height: 15px; margin-right: 10px;"
                src="/img/loading/Rolling-0.6s-204px.svg"
                alt="loader">
              <span class="">Contrat en cours de génération</span>
            </a>
          </div>
        </div>
      </div>
      <div class="columns is-gapless is-marginless has-background-white is-minH64p is-border-top">
        <div
          class="column is-narrow is-flex is-padding-small"
          :class="program.is_valid ? 'has-background-success' : 'has-background-white--darken1'"
          :data-tooltip="program.is_valid ? 'Fiche programme complète' : 'Fiche programme incomplète'">
          <span
            class="icon is-self-centered"
            :class="program.is_valid ? 'has-text-white' : 'has-text-danger'">
            <i
              class="fas"
              :class="program.is_valid ? 'fa-check-circle' : 'fa-exclamation-circle'"></i>
          </span>
        </div>
        <div class="column is-self-centered is-padding-left">
          <div class="title is-4">
            Informations Programme
          </div>
          <div
            v-if="!program.is_valid"
            class="subtitle is-6 has-text-danger">
            Informations manquantes
          </div>
        </div>
        <div
          v-if="!lotIsDeleted && !programIsDeleted && (isPromoteur && isAdmin)"
          class="actionsOnRow actionsOnRow--vertical">
          <div class="is-minH100">
            <!-- seulement à ajouter quand il y a un seul élément-->
            <router-link
              class="tooltip is-tooltip-left"
              data-tooltip="Modifier la fiche programme"
              tag="button"
              :to="{name: 'ProgramEdit', params: {id: program.pk}, query: { check: 1 }}">
              <span class="icon"><i class="fal fa-file-edit"></i></span>
            </router-link>
          </div>
        </div>
      </div>
      <div class="columns is-gapless is-marginless has-background-white is-minH64p is-border-top">
        <div
          class="column is-narrow is-flex is-padding-small"
          :class="lot.is_valid ? 'has-background-success' : 'has-background-white--darken1'"
          :data-tooltip="lot.is_valid ? 'Fiche lot complète' : 'Fiche lot incomplète'">
          <span
            class="icon is-self-centered"
            :class="lot.is_valid ? 'has-text-white' : 'has-text-danger'">
            <i
              class="fas"
              :class="lot.is_valid ? 'fa-check-circle' : 'fa-exclamation-circle'"></i>
          </span>
        </div>
        <template v-if="lot.nature === 'parking'">
          <div class="column is-self-centered is-padding-left">
            <div class="title is-4">
              Informations Stationnement
            </div>
            <div
              v-if="!lot.is_valid"
              class="subtitle is-6 has-text-danger">
              Informations manquantes
            </div>
          </div>
          <div
            v-if="!lotIsDeleted && !programIsDeleted && (isPromoteur && isAdmin)"
            class="actionsOnRow actionsOnRow--vertical">
            <div class="is-minH100">
              <!-- seulement à ajouter quand il y a un seul élément-->
              <router-link
                class="tooltip is-tooltip-left"
                data-tooltip="Modifier la fiche lot"
                tag="button"
                :to="{name: 'LotEdit', params: {id: lot.pk}, query: { check: 1 }}">
                <span class="icon"><i class="fal fa-file-edit"></i></span>
              </router-link>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="column is-self-centered is-padding-left">
            <div class="title is-4">
              Informations Lot
            </div>
            <div
              v-if="!lot.is_valid"
              class="subtitle is-6 has-text-danger">
              Informations manquantes
            </div>
          </div>
          <div
            v-if="!lotIsDeleted && !programIsDeleted && (isPromoteur && isAdmin)"
            class="actionsOnRow actionsOnRow--vertical">
            <div class="is-minH100">
              <!-- seulement à ajouter quand il y a un seul élément-->
              <router-link
                class="tooltip is-tooltip-left"
                data-tooltip="Modifier la fiche lot"
                tag="button"
                :to="{name: 'LotEdit', params: {id: lot.pk}, query: { check: 1 }}">
                <span class="icon"><i class="fal fa-file-edit"></i></span>
              </router-link>
            </div>
          </div>
        </template>
      </div>
      <template v-for="(buyer, index) in buyers">
        <membre-adv
          class="is-border-top has-background-white"
          :key="index"
          :is-grey="true"
          :index="index"
          :membre="buyer"
          :is-co-acquereur="index > 0"
          @updateContact="openModalContactInfo"
          @createAndReplaceBuyers="openReplaceModalContactInfo"
          @deleteCobuyer="deleteBuyer"
          :is-membre-promoteur="false"
          :modal-promoteur="false"
          :can-edit="true"
          :from-resa="true"></membre-adv>
      </template>
      <template v-if="adv.promoteur_data">
        <membre-adv
          class="is-border-top has-background-white"
          :is-grey="true"
          :membre="adv.promoteur_data"
          :is-co-acquereur="false"
          :is-membre-promoteur="true"
          :modal-promoteur="false"
          :can-edit="isAdmin && isPromoteur"
          @openModalPromoteurInfo="openModalPromoteurInfo"
          :from-resa="false"></membre-adv>
      </template>
      <!-- DISPOSITIF PINEL -->
      <!-- <template v-if="adv.tax_dispositif == 'pinel'">
        <div
          class="columns is-gapless is-marginless has-background-white is-minH64p is-border-top">
          <div
            class="column is-narrow is-flex is-padding-small"
            :class="validMandatary ? 'has-background-success' : 'has-background-white--darken1'"
            :data-tooltip="validMandatary ? 'Information complète' : 'Information incomplète'">
            <span
              class="icon is-self-centered"
              :class="validMandatary ? 'has-text-white' : 'has-text-danger'">
              <i
                class="fas"
                :class="validMandatary ? 'fa-check-circle' : 'fa-exclamation-circle'"></i>
            </span>
          </div>
          <div class="column is-self-centered is-padding-left">
            <div class="title is-4">
              Mandataire
            </div>
            <div
              v-if="!validMandatary"
              class="subtitle is-6 has-text-danger">
              Informations manquantes
            </div>
          </div>
        </div>
        <div
          class="columns is-12 is-gapless is-marginless is-padding-left-small is-padding-right-small is-vcentered is-minH50p"
          :class="!adv.mandatary_details.use_custom_mandatary ? 'is-border-top has-background-light is-border-left is-border-right is-border-bottom ' : 'has-background-dark'">
          <div class="column is-narrow">
            <div class="is-padding-top-xsmall is-padding-bottom-xsmall">
              <div>
                <input
                  id="use_custom_mandatary"
                  v-model="adv.mandatary_details.use_custom_mandatary"
                  name="use_custom_mandatary"
                  class="switch is-success is-rounded"
                  type="checkbox">
                <label
                  for="use_custom_mandatary"
                  style="font-size: 12.5px"
                  :class="!adv.mandatary_details.use_custom_mandatary ? '' : 'has-text-white'"
                  class="is-uppercase">Sur définir le mandataire</label>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="adv.mandatary_details.use_custom_mandatary"
          class="is-padding-xsmall notification is-warning columns is-12 is-gapless is-padding-left-small is-padding-right-small is-vcentered is-minH50p is-marginless-bottom">
          <div class="column is-narrow is-8 is-padding-left-small">
            <div class="is-padding-top-xsmall is-padding-bottom-xsmall">
              <span class="is-uppercase is-size-7 has-text-weight-medium">Merci de préciser les frais et commissions directs et indirects présent dans le dossier de réservation</span>
            </div>
          </div>
          <div class="column is-narrow is-3 is-padding-left-large">
            <div class="field has-addons">
              <div class="control">
                <a class="button is-static is-border is-square">
                  <span class="icon"><i class="fas fa-euro-sign"></i></span>
                </a>
              </div>
              <div class="control is-expanded">
                <v-input
                  id="profit"
                  name="profit"
                  @input="val => updateMandataryDetails('profit', val)"
                  :model="adv.mandatary_details.profit"
                  :class="{'tooltip is-tooltip-right' : !(isAdmin && isPromoteur)}"
                  data-tooltip="Champs à renseigner par le promoteur"
                  :disabled="!(isAdmin && isPromoteur)"
                  v-validate="'decimal:2'"
                  :errors-bag="errors"
                  data-vv-value-path="val"
                  :number="true"
                  input-type="number"
                  data-vv-as="">
                </v-input>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="adv.mandatary_details.use_custom_mandatary"
          class="is-border-top has-background-white is-padding">
          <div
            v-for="(mandataire, i) in adv.mandatary_details.mandataries"
            :key="'mandataire'+i">
            <div class="columns is-multiline is-padding-top">
              <div class="column is-11 is-uppercase">
                Mandataire {{ i + 1 }}
              </div>
              <div
                v-if="i >= 1"
                class="column is-1">
                <a
                  class="button is-square is-grey is-inverted is-border is-pulled-right"
                  @click.prevent.stop="removeMandatary(i)">
                  <i class="fal fa-trash-alt" />
                </a>
              </div>
            </div>
            <div class="columns">
              <div class="column is-6 is-3-widesreen">
                <r-label
                  :label="'Nom et Prénom'"
                  :is-required="true"
                  :value="mandataire.name"></r-label>
                <v-input
                  :id="'mandatary_name_' + i"
                  :name="'mandatary_name_' + i"
                  @input="val => updateMandataryData('name', val, i)"
                  :model="mandataire.name"
                  data-vv-as="Nom et Prénom"
                  v-validate="'min:2'"
                  :errors-bag="errors"
                  data-vv-value-path="val">
                </v-input>
              </div>
              <div class="column is-6 is-3-widesreen">
                <r-label
                  :label="'Société'"
                  :is-required="true"
                  :value="mandataire.company"></r-label>
                <v-input
                  :id="'madatary_company' + i"
                  :name="'madatary_company' + i"
                  @input="val => updateMandataryData('company', val, i)"
                  :model="mandataire.company"
                  data-vv-as="Société"
                  v-validate="'min:2'"
                  :errors-bag="errors"
                  data-vv-value-path="val">
                </v-input>
              </div>
            </div>
            <div class="columns is-multiline">
              <div class="column is-6">
                <r-label
                  :label="'Adresse'"
                  :is-required="true"
                  :value="mandataire.address"></r-label>
                <v-input
                  :id="'mandatary_address' + i"
                  :name="'mandatary_address' + i"
                  @input="val => updateMandataryData('address', val, i)"
                  :model="mandataire.address"
                  data-vv-as="Adresse"
                  v-validate=""
                  :errors-bag="errors"
                  data-vv-value-path="val">
                </v-input>
              </div>
              <div class="column is-4 is-3-widesreen">
                <r-label
                  :label="`Rémunération`"
                  :is-required="true"
                  :force-red="remRedCheck"
                  :value="mandataire.remuneration"></r-label>
                <div class="field has-addons is-marginless-bottom">
                  <div class="control">
                    <a class="button is-square is-static is-border"><span class="icon"><i
                      class="fas fa-percent"></i></span></a>
                  </div>
                  <div class="control is-expanded">
                    <v-input
                      :id="'remuneration_' + i"
                      :name="'remuneration_' + i"
                      @input="val => updateMandataryRem(val, i)"
                      :model="mandataire.remuneration"
                      v-validate="'decimal:2'"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      :number="true"
                      input-type="number"
                      data-vv-as="">
                      <span slot="provocatedError">
                        <p
                          v-if="remRedCheck"
                          class="help is-danger">
                          Le total ne peut excéder le taux du mandat ({{ adv.seller_remuneration }} %)
                        </p>
                      </span>
                    </v-input>
                    <input
                      name="remuneration"
                      v-model.number="mandataire.remuneration"
                      max="100"
                      @update="val => updateMandataryData('remuneration', val, i)"
                      class="input"
                      :step="0.1"
                      type="number"
                      data-type-cy="input"
                      data-value-cy="remuneration">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="adv.mandatary_details.mandataries.length < 2"
            class="is-padding-top has-text-right">
            <a
              @click="addNewMandatary"
              class="button is-rounded is-transform-none is-padding-right-large is-padding-left-large">
              &nbsp;<span class="icon is-small has-text-grey"><i class="fas fa-plus-square" /></span><span>Ajouter un mandataire</span></a>
          </div>
        </div>
      </template> -->
      <div class="columns is-gapless is-marginless has-background-white is-minH64p is-border-top">
        <div
          class="column is-narrow is-flex is-padding-small"
          :class="validFinancement ? 'has-background-success' : 'has-background-white--darken1'"
          :data-tooltip="validFinancement ? 'Information complète' : 'Information incomplète'">
          <span
            class="icon is-self-centered"
            :class="validFinancement ? 'has-text-white' : 'has-text-danger'">
            <i
              class="fas"
              :class="validFinancement ? 'fa-check-circle' : 'fa-exclamation-circle'"></i>
          </span>
        </div>
        <div class="column is-self-centered is-padding-left">
          <div class="title is-4">
            Financement
          </div>
          <div
            v-if="!validFinancement"
            class="subtitle is-6 has-text-danger">
            Informations manquantes
          </div>
        </div>
      </div>
      <div
        class="columns is-12 is-gapless is-marginless is-padding-left-small is-padding-right-small is-vcentered is-minH50p"
        :class="!not_using_loan ? 'is-border-top has-background-light is-border-left is-border-right is-border-bottom ' : 'has-background-dark'">
        <div class="column is-narrow">
          <div class="is-padding-top-xsmall is-padding-bottom-xsmall">
            <div>
              <input
                id="use_loan"
                v-model="not_using_loan"
                name="use_loan"
                class="switch is-success is-rounded"
                type="checkbox">
              <label
                for="use_loan"
                style="font-size: 12.5px"
                :class="!not_using_loan ? '' : 'has-text-white'"
                class="is-uppercase">Le réservataire déclare ne pas recourir à un ou plusieurs prêt
                bancaire</label>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!not_using_loan"
        class="is-border-top is-padding has-background-white">
        <div class="is-padding-top-xsmall is-padding-bottom-xsmall">
          <div class="columns">
            <!-- Garanti prêt -->
            <div class="column is-4 columns is-column is-gapless is-space-between is-marginless is-centered">
              <div
                class="control column is-narrow is-paddingless">
                <input
                  class="switch is-success is-rounded"
                  id="use_caution"
                  type="checkbox"
                  name="use_caution"
                  @input="$store.commit('modifyCurrentAdv', { key: 'funding_data.use_caution', value: adv.funding_data.use_caution })"
                  v-model="adv.funding_data.use_caution">
                <label
                  for="use_caution"
                  class="is-uppercase">
                  <span
                    class="is-size-6 is-margin-top-xxsmall">Garanti par une caution</span>
                </label>
              </div>
            </div>
            <div class="column is-4 columns is-column is-gapless is-space-between is-marginless is-centered">
              <div
                class="control column is-narrow is-paddingless">
                <input
                  class="switch is-success is-rounded"
                  id="use_hypotheque"
                  type="checkbox"
                  name="use_hypotheque"
                  @input="$store.commit('modifyCurrentAdv', { key: 'funding_data.use_hypotheque', value: adv.funding_data.use_hypotheque })"
                  v-model="adv.funding_data.use_hypotheque">
                <label
                  for="use_hypotheque"
                  class="is-uppercase">
                  <span
                    class="is-size-6 is-margin-top-xxsmall">Garanti par une hypothèque</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="columns is-gapless is-multiline">
          <div class="column is-12 is-6-widesreen">
            <r-label
              :label="'Organisme bancaire'"
              :is-required="false"
              :value="adv.funding_data.initial_bank_name"></r-label>
            <v-input
              id="initial_bank_name"
              name="initial_bank_name"
              @input="val => updateFundingData('initial_bank_name', val)"
              :model="adv.funding_data.initial_bank_name"
              data-vv-as="Organisme bancaire"
              v-validate="'min:2'"
              :errors-bag="errors"
              data-vv-value-path="val">
            </v-input>
          </div>
        </div>
        <div class="columns is-multiline">
          <div class="column is-4">
            <r-label
              :label="'MONTANT MAXIMUM À EMPRUNTER'"
              :value="adv.funding_data.initial_loan_value"
              :red-check="true"></r-label>
            <div class="field has-addons">
              <div class="control">
                <a class="button is-static is-border is-square">
                  <span class="icon"><i class="fas fa-euro-sign"></i></span>
                </a>
              </div>
              <div class="control is-expanded">
                <v-input
                  id="initial_loan_value"
                  name="initial_loan_value"
                  @input="val => updateFundingData('initial_loan_value', val)"
                  :model="adv.funding_data.initial_loan_value"
                  class=""
                  :three-space="true"
                  v-validate="'decimal:2'"
                  :errors-bag="errors"
                  data-vv-value-path="val"
                  :number="true"
                  input-type="number"
                  data-vv-as="Montant maximum à emprunter">
                </v-input>
              </div>
            </div>
          </div>
          <div class="column is-4">
            <r-label
              :label="'MONTANT DE L\'APPORT'"
              :value="adv.funding_data.contribution_amount"
              :red-check="true"></r-label>
            <div class="field has-addons">
              <div class="control">
                <a class="button is-static is-border is-square">
                  <span class="icon"><i class="fas fa-euro-sign"></i></span>
                </a>
              </div>
              <div class="control is-expanded">
                <v-input
                  id="contribution_amount"
                  name="contribution_amount"
                  @input="val => updateFundingData('contribution_amount', val)"
                  :model="adv.funding_data.contribution_amount"
                  class=""
                  v-validate="'decimal:2'"
                  :errors-bag="errors"
                  data-vv-value-path="val"
                  :number="true"
                  :three-space="true"
                  input-type="number"
                  data-vv-as="Montant de l'apport">
                </v-input>
              </div>
            </div>
          </div>
          <div class="column is-4">
            <r-label
              :label="'ORIGINE DE L\'APPORT'"
              :is-required="false"
              :value="adv.funding_data.origin_contribution"></r-label>
            <v-input
              id="origin_contribution"
              name="origin_contribution"
              @input="val => updateFundingData('origin_contribution', val)"
              :model="adv.funding_data.origin_contribution"
              data-vv-as="Origine de l'apport"
              v-validate="'min:2'"
              :errors-bag="errors"
              data-vv-value-path="val">
            </v-input>
          </div>
          <div class="column is-2 s-3-widesreen">
            <r-label
              :label="'DURÉE max du prêt'"
              :value="adv.funding_data.initial_loan_duration"
              :is-required="false"></r-label>
            <div class="field has-addons">
              <div class="control">
                <a class="button is-static is-border is-square">
                  <span class="icon"><i class="far fa-clock"></i></span>
                </a>
              </div>
              <div class="control is-expanded">
                <v-input
                  id="initial_loan_duration"
                  name="initial_loan_duration"
                  @input="val => updateFundingData('initial_loan_duration', val)"
                  :model="adv.funding_data.initial_loan_duration"
                  :placeholder="'en année'"
                  data-vv-as="Durée max du prêt"
                  v-validate="'min:1'"
                  :errors-bag="errors"
                  data-vv-value-path="val">
                </v-input>
              </div>
            </div>
          </div>
          <div class="column is-2 is-3-widesreen">
            <r-label
              :label="`taux d’interêt max`"
              :is-required="false"
              :value="adv.funding_data.initial_loan_rate"></r-label>
            <div class="field has-addons is-marginless-bottom">
              <div class="control">
                <a class="button is-square is-static is-border"><span class="icon"><i
                  class="fas fa-percent"></i></span></a>
              </div>
              <div class="control is-expanded">
                <input
                  name="initial_loan_rate"
                  v-model.number="adv.funding_data.initial_loan_rate"
                  max="100"
                  @input="$store.commit('modifyCurrentAdv', { key: 'funding_data.initial_loan_rate', value: adv.funding_data.initial_loan_rate})"
                  class="input"
                  :step="0.1"
                  type="number"
                  data-type-cy="input"
                  data-value-cy="initial_loan_rate">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="columns is-12 is-gapless is-padding-left-small is-padding-right-small is-vcentered is-minH50p is-marginless-bottom"
        :class="!adv.funding_data.security_deposit ? ' has-background-light is-border-left is-border-right ' : 'has-background-dark'">
        <div class="column is-narrow">
          <div class="is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right">
            <div>
              <input
                id="security_deposit"
                v-model="adv.funding_data.security_deposit"
                name="security_deposit"
                class="switch is-success is-rounded"
                type="checkbox">
              <label
                for="security_deposit"
                :class="!adv.funding_data.security_deposit ? '' : 'has-text-white'"
                style="font-size: 12.5px"
                class="is-uppercase">Dépot de garantie déposé à la signature</label>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="adv.funding_data.security_deposit"
        class="is-padding-xsmall notification is-multiline is-warning columns is-12 is-gapless is-padding-left-small is-padding-right-small is-vcentered is-minH50p is-marginless-bottom">
        <div class="column is-narrow is-12 is-padding-left-large">
          <div class="is-padding-top-xsmall is-padding-bottom-xsmall">
            <span class="is-uppercase is-size-7 has-text-weight-medium">Merci de préciser le montant et le type du dépot de garantie déposé à la signature du contrat de réservation</span>
          </div>
        </div>
        <div class="column is-narrow is-4 is-padding-left-large">
          <div class="field has-addons">
            <div class="control">
              <a class="button is-static is-border is-square">
                <span class="icon"><i class="fas fa-euro-sign"></i></span>
              </a>
            </div>
            <div class="control is-expanded">
              <v-input
                id="security_deposit_value"
                name="security_deposit_value"
                @input="val => setPercentageContribution(val)"
                :model="adv.funding_data.security_deposit_value"
                class=""
                v-validate="'decimal:2'"
                :errors-bag="errors"
                data-vv-value-path="val"
                :number="true"
                :three-space="true"
                input-type="number"
                data-vv-as="">
              </v-input>
            </div>
          </div>
        </div>
        <div class="column is-narrow is-4 is-padding-left-large">
          <div class="field has-addons">
            <div class="control is-expanded">
              <v-input
                id="percentage_contribution"
                name="percentage_contribution"
                @input="val => setSecurityDepositValue(val)"
                :model="adv.funding_data.percentage_contribution"
                class=""
                v-validate="'decimal:2'"
                :errors-bag="errors"
                data-vv-value-path="val"
                :number="true"
                input-type="number"
                data-vv-as="">
              </v-input>
            </div>
            <div class="control">
              <a class="button is-static is-border is-square">
                <i class="fas fa-percentage"></i>
              </a>
            </div>
          </div>
        </div>
        <div class="column is-narrow is-4 is-padding-left-large">
          <div class="select is-fullwidth">
            <select
              v-model="adv.funding_data.security_deposit_type">
              <option
                :value="null"
                disabled
                selected>
                Selectionnez
              </option>
              <option
                v-for="s in securityDepositeTypeList"
                :value="s.value"
                :key="s.value">
                {{ s.label }}
              </option>
            </select>
          </div>
        </div>
        <div class="column is-4 is-padding-left-large is-padding-top-xsmall">
          <date-picker
            :model="adv.funding_data.loan_payment_date"
            :is-required="false"
            :red-check="true"
            :style-version="2"
            @input="$store.commit('modifyCurrentAdv', { key: `funding_data.loan_payment_date`, value: $event})"
            label="Date versement acompte"></date-picker>
        </div>
        <div
          class="column is-4 is-padding-left-large is-padding-top-xsmall">
          <r-label
            label="Acompte versé à"
            :is-required="false"
            :value="adv.funding_data.deposit_paid_to"></r-label>
          <div class="control">
            <multiselect
              v-model="adv.funding_data.deposit_paid_to"
              :options="filteredDepositPaidList"
              class="multiselect--option-ico"
              :multiple="true"
              :close-on-select="false"
              :placeholder="''"
              track-by="value"
              label="label">
              <span
                slot="placeholder"
                class="multiselect__placeholder">Selectionner un type</span>
              <span slot="noOptions">La liste est vide</span>
            </multiselect>
          </div>
        </div>
      </div>
      <div class="is-border-top columns is-gapless is-border-bottom is-marginless-bottom">
        <div
          class="column is-narrow is-flex is-padding-small"
          :class="validNotary ? 'has-background-success' : 'has-background-white--darken1 tooltip is-tooltip-right'"
          :data-tooltip="'Notaire client incomplet'">
          <span
            class="icon has-text-white is-self-centered"
            :class="validNotary ? 'has-text-white' : 'has-text-danger'"><i
              :class="validNotary ? 'fa-check-circle' : 'fa-exclamation-circle'"
              class="fas"></i></span>
        </div>
        <div class="column has-background-white">
          <div class="is-padding">
            <span class="is-uppercase is-6">Notaire client</span>
          </div>
          <div
            class="is-padding-left-small is-padding-right-small is-flex is-minH50p is-border-top"
            :class="!adv.notary_details.use_buyer_notary ? 'has-background-light ' : ' has-background-dark'">
            <div class="is-self-centered is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right">
              <div>
                <input
                  id="use_buyer_notary"
                  v-model="adv.notary_details.use_buyer_notary"
                  name="use_buyer_notary"
                  class="switch is-success is-rounded"
                  type="checkbox">
                <label
                  for="use_buyer_notary"
                  :class="!adv.notary_details.use_buyer_notary ? '' : 'has-text-white'"
                  class="is-uppercase">Renseigner le notaire du client</label>
              </div>
            </div>
          </div>
          <div
            v-if="adv.notary_details.use_buyer_notary"
            class="is-border-top is-padding">
            <div class="columns is-multiline">
              <div class="column is-6">
                <r-label
                  :label="adv.notary_details.tiers_id ? 'Notaire du référentiel' : 'Rechercher un notaire au référentiel'"
                  :is-required="false"
                  :value="adv.notary_details.tiers_id" />
                <tiers-selector
                  :selected="selectedNotaireClient"
                  :slot-ref="adv.notary_details"
                  :types="['notaire']"
                  placeholder="Nom, ville..."
                  @select="selectNotaireClient"
                  @unlink="unlinkNotaireClient" />
              </div>
              <div class="column is-6"></div>
              <div class="column is-6">
                <r-label
                  label="Nom du notaire"
                  :is-required="true"
                  :red-check="true"
                  :value="adv.notary_details.name"></r-label>
                <div class="control">
                  <v-input
                    id="adv.notary_details.name"
                    :disabled="!!adv.notary_details.tiers_id"
                    name="adv.notary_details.name"
                    :model="adv.notary_details.name"
                    v-validate="'min:2'"
                    @input="val => updateNotaryDetails('name', val)"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    classes="input"
                    data-vv-as="Nom du notaire">
                  </v-input>
                </div>
              </div>
              <div class="column is-6">
                <r-label
                  label="Téléphone du notaire"
                  :is-required="true"
                  :red-check="true"
                  :value="adv.notary_details.phone"
                  :truncate="false">
                  <span
                    class="is-padding-left-xsmall"
                    v-helper.right="'6BNfgrh0uP7V5UyMRsZvQp'">
                    <i class="fal fa-info-circle"></i>
                  </span>
                </r-label>
                <div class="control">
                  <v-input
                    id="adv.notary_details.phone"
                    :disabled="!!adv.notary_details.tiers_id"
                    name="adv.notary_details.phone"
                    :model="adv.notary_details.phone"
                    v-validate="'min:10'"
                    @input="val => updateNotaryDetails('phone', val)"
                    :placeholder="'06xxxxxxxx / +336xxxxxxxx'"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    data-vv-as="Téléphone"
                    :has-addons="true">
                    <p
                      class="control"
                      slot="addonLeft">
                      <a class="button is-static is-square is-static">
                        <span class="icon"><i class="fas fa-phone-office"></i></span>
                      </a>
                    </p>
                  </v-input>
                </div>
              </div>
              <div class="column is-6">
                <r-label
                  label="Email"
                  :value="adv.notary_details.email"
                  :is-required="true"
                  :red-check="true"></r-label>
                <div class="control">
                  <v-input
                    :has-addons="true"
                    id="adv.notary_details.email"
                    :disabled="!!adv.notary_details.tiers_id"
                    name="adv.notary_details.email"
                    :model="adv.notary_details.email"
                    v-validate="'email'"
                    :errors-bag="errors"
                    @input="val => updateNotaryDetails('email', val)"
                    data-vv-value-path="val"
                    data-vv-as="Email">
                    <p
                      class="control"
                      slot="addonLeft">
                      <a class="button is-static is-square is-static">
                        <span class="icon"><i class="fas fa-paper-plane"></i></span>
                      </a>
                    </p>
                  </v-input>
                </div>
              </div>
              <div class="column is-12">
                <address-input
                  v-if="!adv.notary_details.tiers_id"
                  label="Adresse de correspondance"
                  @update="val => updateNotaryDetails('address', val)"
                  :source="adv.notary_details.address"
                  :is-required="true"
                  :red-check="true">
                </address-input>
                <div
                  v-else
                  class="columns is-multiline">
                  <div class="column is-6">
                    <r-label
                      label="Adresse de correspondance"
                      :is-required="false"
                      :value="tiersAddressResume(adv.notary_details.address)" />
                    <input
                      :value="tiersAddressResume(adv.notary_details.address)"
                      type="text"
                      class="input"
                      disabled>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Mention particulière -->
      <div
        v-if="isAdmin && isPromoteur"
        class="has-background-white is-border-top">
        <div class="row-width-actions-bar columns is-gapless is-marginless">
          <div class="column is-self-centered is-padding-left is-padding-top-xsmall is-padding-bottom-xsmall">
            <span class="is-uppercase title is-6">Mention particulière</span>
          </div>
          <div class="column is-narrow is-border-left">
          </div>
        </div>
        <template v-if="openComment">
          <div
            v-if="!openMentionCommentWysi && mention_comment"
            @click="openWysiwyg"
            class="vadDiscussion is-border-top"
            style="cursor: pointer;">
            <div
              class="vadDiscussion--bulle is-size-6 is-minH50p vadDiscussion--bulle--has-actions is-cut is-padding-left">
              <div
                class="content"
                v-if="isAdmin && mention_comment"
                v-html="mention_comment"></div>
              <div class="actionsOnRow actionsOnRow--vertical">
                <div class="">
                  <button
                    @click="openWysiwyg"
                    class="is-min-height-full">
                    <span class="icon is-small"><i class="fal fa-edit"></i></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
            class="is-border-top columns is-gapless">
            <div class="column">
              <wysiwyg-editor
                :light="true"
                :tooltip-top="true"
                :model="mention_comment"
                @change="val => mention_comment = val"
                class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
              </wysiwyg-editor>
            </div>
            <div class="actionsOnRow actionsOnRow--vertical">
              <div>
                <button
                  @click="patchMentionComment()"
                  type="button"
                  class="button"
                  :class="[(baseMentionComment !== mention_comment) ? 'is-success' : 'is-info']"
                  :disabled="(baseMentionComment === mention_comment)">
                  <span class="icon is-small">
                    <i
                      v-if="loadMentionComment"
                      class="fas fa-spinner fa-spin"></i>
                    <i
                      v-else
                      class="fal fa-save"></i>
                  </span>
                </button>
              </div>
              <div class="">
                <button
                  :disabled="!baseMentionComment"
                  type="button"
                  :class="{'actionsOnRow-btn--hoverIsDanger': mention_comment}"
                  @click="mention_comment?openCommentWysi = false:null; mention_comment = baseMentionComment">
                  <span class="icon is-small"><i class="fal fa-times"></i></span>
                </button>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="has-background-white is-margin-top-xsmall">
        <div class="columns is-gapless is-marginless has-background-white is-minH64p is-border-top">
          <div
            class="column is-narrow is-flex is-padding-small"
            :class="validDocument ? 'has-background-success' : 'has-background-white--darken1'"
            :data-tooltip="validDocument ? 'Fiche programme complète' : 'Fiche programme incomplète'">
            <span
              class="icon is-self-centered"
              :class="validDocument ? 'has-text-white' : 'has-text-danger'">
              <i
                class="fas"
                :class="validDocument ? 'fa-check-circle' : 'fa-exclamation-circle'"></i>
            </span>
          </div>
          <div class="column is-self-centered is-padding-left">
            <div class="title is-4">
              Documents annexés
            </div>
            <div
              v-if="!validDocument"
              class="subtitle is-6 has-text-danger">
              Informations manquantes
            </div>
          </div>
        </div>
        <div class="is-padding-left is-padding-right has-background-white is-padding-top-xsmall is-padding-bottom-xsmall is-minH50p is-flex is-border-top">
          <div class="is-self-centered">
            <span class="is-uppercase title is-6 has-text-weight-normal">Liste des documents attendus en annexe</span>
          </div>
        </div>
        <div class="notification is-warning is-marginless is-minH75p is-flex">
          <div class="is-self-centered w100 is-uppercase is-size-7 has-text-weight-medium">
            Tous les documents ci-dessous doivent être téléchargés pour être annexés au contrat de réservation.<br>
            L'icône <span class="icon is-small has-text-success"><i class="fas fa-check-circle"></i></span> signale que
            le fichier téléchargé est correctement lié.
          </div>
        </div>
        <div class="is-padding">
          <div class="is-border">
            <div
              v-dragula="contratDeReservationDocuments"
              drake="one"
              v-if="isAdmin && isPromoteur">
              <document-list-item
                v-for="(doc, idx) in contratDeReservationDocuments"
                :source="doc"
                :all-documents="allDocuments"
                :key="doc.key + '-document'"
                :index="idx"
                :can-drag="true"
                :selected-row="selectedRow"
                @selectedRow="val => selectedRow = val"
                @update="$store.commit('modifyCurrentAdv', { key: 'documents', value: contratDeReservationDocuments})"
                @rotateDocument="rotateDocument({ document: $event.document, rotation: $event.rotation, target: 'documents' })"
                @remove="removeContratDocument">
              </document-list-item>
            </div>
            <div v-if="!(isAdmin && isPromoteur)">
              <document-list-item
                v-for="(doc, idx) in contratDeReservationDocuments"
                :source="doc"
                :all-documents="allDocuments"
                :key="doc.key + '-document'"
                :index="idx"
                :can-drag="false"
                :selected-row="selectedRow"
                @selectedRow="val => selectedRow = val"
                @update="$store.commit('modifyCurrentAdv', { key: 'documents', value: contratDeReservationDocuments})"
                @rotateDocument="rotateDocument({ document: $event.document, rotation: $event.rotation, target: 'documents' })"
                @remove="removeContratDocument">
              </document-list-item>
            </div>
            <div
              v-if="isAdmin && isPromoteur"
              class="">
              <button
                @click="addNewAnnexDocument"
                class="button is-dark is-fullwidth is-radiusless is-minH50p">
                <span>Ajouter un document à la liste</span>
              </button>
            </div>
          </div>
        </div>
        <!-- Commentaire -->
        <div
          v-if="isAdmin && isPromoteur || currentUser.active_all_contact"
          class="has-background-white is-border-top">
          <div class="row-width-actions-bar columns is-gapless is-marginless">
            <div class="column is-self-centered is-padding-left is-padding-top-xsmall is-padding-bottom-xsmall">
              <span class="is-uppercase title is-6">Commentaire</span>
            </div>
            <div class="column is-narrow is-border-left">
            </div>
          </div>
          <template v-if="openComment">
            <div
              v-if="!openCommentWysi && comment"
              @click="openWysiwyg"
              class="vadDiscussion is-border-top"
              style="cursor: pointer;">
              <div
                class="vadDiscussion--bulle is-size-6 is-minH50p vadDiscussion--bulle--has-actions is-cut is-padding-left">
                <div
                  class="content"
                  v-if="(isAdmin || currentUser.active_all_contact) && comment"
                  v-html="comment"></div>
                <div class="actionsOnRow actionsOnRow--vertical">
                  <div class="">
                    <button
                      @click="openWysiwyg"
                      class="is-min-height-full">
                      <span class="icon is-small"><i class="fal fa-edit"></i></span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else
              class="is-border-top columns is-gapless">
              <div class="column">
                <wysiwyg-editor
                  :light="true"
                  :tooltip-top="true"
                  :model="comment"
                  @change="val => comment = val"
                  class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
                </wysiwyg-editor>
              </div>
              <div class="actionsOnRow actionsOnRow--vertical">
                <div>
                  <button
                    @click="patchComment()"
                    type="button"
                    class="button"
                    :class="[(baseComment !== comment) ? 'is-success' : 'is-info']"
                    :disabled="(baseComment === comment)">
                    <span class="icon is-small">
                      <i
                        v-if="loadComment"
                        class="fas fa-spinner fa-spin"></i>
                      <i
                        v-else
                        class="fal fa-save"></i>
                    </span>
                  </button>
                </div>
                <div class="">
                  <button
                    :disabled="!baseComment"
                    type="button"
                    :class="{'actionsOnRow-btn--hoverIsDanger': comment}"
                    @click="comment?openCommentWysi = false:null; comment = baseComment">
                    <span class="icon is-small"><i class="fal fa-times"></i></span>
                  </button>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Adv, DefaultValues, Quickview } from '@/mixins'
import { mapGetters, mapState } from 'vuex'
import uuidv4 from 'uuid/v4'
import { cloneDeep } from 'lodash'
import TiersLink from '@/components/tiers/TiersLinkMixin'

export default {
  name: 'ContratDeReservation',
  components: {
    MembreAdv: () => import('../MembreAdv'),
    DocumentListItem: () => import('../DocumentListItem'),
    TiersSelector: () => import('@/components/tiers/TiersSelector')
  },
  mixins: [Adv, DefaultValues, Quickview, TiersLink],
  data () {
    return {
      selectedRow: null,
      not_using_loan: false,
      remRedCheck: false,
      lastedData: [],
      selectedNotaireClient: null
    }
  },
  computed: {
    ...mapState(['currentUser', 'modal', 'quickview']),
    ...mapGetters(['isAdmin', 'isPromoteur']),
    /**
       * can submit dossier resa
       * @returns {boolean}
       */
    canSubmitDossierResa () {
      return this.lot.is_valid && this.program.is_valid
    },
    /**
       * current user is adv user
       * @returns {boolean}
       */
    isAdvUser () {
      return this.currentUser.pk === this.adv.user.pk
    },
    /**
       * mandatary is valid
       * @returns {boolean}
       */
    validMandatary () {
      if (!this.adv.mandatary_details.use_custom_mandatary) {
        return true
      } else {
        // if (this.remRedCheck) {
        //   return false
        // }
        if (this.adv.mandatary_details.profit === '' || this.adv.mandatary_details.profit == null) {
          return false
        }
        let mandataries = cloneDeep(this.adv.mandatary_details.mandataries)
        mandataries = mandataries.filter(x => this.checkFull(x))
        if (mandataries.length <= 0 || mandataries.length > 2 || mandataries.length !== this.adv.mandatary_details.mandataries.length) {
          return false
        }
        return true
      }
    },
    /**
       * financement is valid
       * @returns {boolean}
       */
    validFinancement () {
      if (!this.adv.funding_data.use_loan) {
        if (this.adv.funding_data.security_deposit) {
          return this.adv.funding_data.security_deposit_value !== null && this.adv.funding_data.security_deposit_value !== '' && this.adv.funding_data.security_deposit_type !== null
        } else {
          return true
        }
      } else {
        if (this.adv.funding_data.security_deposit) {
          return this.adv.funding_data.initial_loan_value !== null && this.adv.funding_data.initial_loan_value !== '' &&
              this.adv.funding_data.security_deposit_value !== null && this.adv.funding_data.security_deposit_value !== '' && this.adv.funding_data.security_deposit_type !== null
        } else {
          return this.adv.funding_data.initial_loan_value !== null && this.adv.funding_data.initial_loan_value !== ''
        }
      }
    },
    validNotary () {
      if (this.adv.notary_details.use_buyer_notary) {
        return this.adv.notary_details.name !== null && this.adv.notary_details.name !== '' && this.adv.notary_details.phone !== null && this.adv.notary_details.phone !== '' && this.adv.notary_details.email !== null && this.adv.notary_details.email !== '' && this.adv.notary_details.address !== null && this.adv.notary_details.address !== ''
      } else {
        return true
      }
    },
    /**
       * document is valid
       * @returns {boolean}
       */
    validDocument () {
      this.contratDeReservationDocuments.forEach(x => {
        if (x.document !== null) {
          if (x.document.cloudinary_id === null && x.document.cloudinary_version === null &&
              x.document.display === null && x.document.filename === null && x.document.fus_id === null && x.document.path === null &&
              x.document.s3_key === null && x.document.s3_path === null) x.document = null
        }
      })
      return !this.contratDeReservationDocuments.find(x => {
        return x.document === null
      })
    },
    /**
       * return lot plan in array
       * @returns {array}
       */
    lotPlan () {
      if (this.lot && this.lot.plan && 'cloudinary_id' in this.lot.plan) {
        let plan = []
        plan.push(this.lot.plan)
        if (plan) {
          return plan
        } else {
          return []
        }
      } else {
        return []
      }
    },
    /**
       * all documents by lot and programme
       * @returns {object}
       */
    allDocuments () {
      let contactDoc = this.buyers.filter(x => 'documents' in x && x.documents !== null && x.documents.length > 0).reduce((docList, buyer) => {
        return [...docList, ...buyer.documents]
      }, [])
      return {
        lot_documents: {
          label: 'Lot',
          documents: this.lot && this.lot.documents ? [...this.lot.documents, ...this.lotPlan] : []
        },
        program_documents: {
          label: 'Programme',
          documents: this.program && this.program.documents ? [...this.program.documents] : []
        },
        contact_documents: {
          label: 'Contact',
          documents: contactDoc
        }
      }
    },
    contractName () {
      if (this.adv.contract_in_use != null) {
        let name = null
        for (let contract of this.program.contracts) {
          if (contract.pk === this.adv.contract_in_use) {
            name = contract.name
          }
        }
        if (name == null) {
          if (this.program.contract_in_use) {
            let contract = this.program.contracts.find(x => x.pk === this.program.contract_in_use)
            name = contract.name
            this.$store.commit('modifyCurrentAdv', { key: 'contract_in_use', value: this.program.contract_in_use })
          } else {
            name = 'Contrat de Vadimm par défaut'
            this.$store.commit('modifyCurrentAdv', { key: 'contract_in_use', value: null })
          }
        }
        return name
      } else {
        return 'Contrat de Vadimm par défaut'
      }
    },
    filteredDepositPaidList () {
      return this.DepositPaidList.filter(x => !x.hide)
    }
  },
  watch: {
    quickview ({ mode, params, results }) {
      if (results) {
        if (mode === 'CONTACT_SELECTION') {
          if (results.entities.length) {
            results.entities.forEach(x => {
              if (params.note === 'replaceBuyer') {
                this.createAndReplaceBuyers(x, params.index)
                this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
              } else {
                this.addContact(x)
              }
            })
          } else {
            this.$toasted.global.danger('Veuillez sélectionner un utilisateur')
          }
        } else if (mode === 'CONTACT_UPDATE' && params && params.fromBuyerEdit) {
          this.putBuyerAndUpdate(results.contact, params.index, params.advProgram).then(ok => {
            if (ok) this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
          })
        } else if (mode === 'PROMOTEUR_UPDATE') {
          this.$store.commit('modifyCurrentAdv', { key: 'promoteur_data', value: results.promoteur })
          this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
        }
      }
    },
    'adv.documents': {
      handler: function (to) {
        this.contratDeReservationDocuments = to
      },
      deep: true
    },
    'not_using_loan' (to) {
      if (to === this.adv.funding_data.use_loan) {
        this.$store.commit('modifyCurrentAdv', { key: 'funding_data.use_loan', value: !to })
        // this.adv.funding_data.use_loan = !to
      }
    },
    'adv.funding_data.security_deposit' (to) {
      this.$store.commit('modifyCurrentAdv', { key: 'funding_data.security_deposit', value: to })
    },
    'adv.funding_data.security_deposit_type' (to) {
      this.$store.commit('modifyCurrentAdv', { key: 'funding_data.security_deposit_type', value: to })
    },
    'adv.notary_details.use_buyer_notary' (to) {
      this.$store.commit('modifyCurrentAdv', { key: 'notary_details.use_buyer_notary', value: to })
    },
    'adv.mandatary_details.use_custom_mandatary' (to) {
      this.$store.commit('modifyCurrentAdv', { key: 'mandatary_details.use_custom_mandatary', value: to })
      if (to === true && this.adv.mandatary_details.mandataries.length === 0) {
        this.adv.mandatary_details.mandataries.push({ name: this.adv.seller_data.first_name + ' ' + this.adv.seller_data.last_name, company: this.adv.seller_data.account.name, address: this.adv.seller_data.account.address, remuneration: this.adv.seller_remuneration })
      }
    },
    'adv.funding_data.deposit_paid_to' (to) {
      if (this.lastedData.length !== to.length) {
        this.lastedData = to
        this.$store.commit('modifyCurrentAdv', { key: 'funding_data.deposit_paid_to', value: to })
      }
    },
    modal ({ mode, params, results }) {
      if (results) {
        if (mode === 'REPLACE_BUYER_CONTACT') {
          this.createAndReplaceBuyers(results.contact, results.index)
        } else if (mode === 'CONTRACT_SELECT_MODAL') {
          if (results.pk == null) {
            this.$store.commit('modifyCurrentAdv', { key: 'contract_in_use', value: null })
          } else {
            this.$store.commit('modifyCurrentAdv', { key: 'contract_in_use', value: results.pk })
          }
        }
      }
    }
  },
  created () {
    if (!Array.isArray(this.adv.funding_data.deposit_paid_to)) this.adv.funding_data.deposit_paid_to = []
    this.not_using_loan = !this.adv.funding_data.use_loan
    if (this.adv.mandatary_details.use_custom_mandatary) {
      let totalRem
      for (var mandatarie of this.adv.mandatary_details.mandataries) {
        if (totalRem == null) {
          totalRem = mandatarie.remuneration
        } else {
          totalRem = totalRem + mandatarie.remuneration
        }
      }
      this.checkDocuments()
      // if (totalRem > this.adv.seller_remuneration) {
      //   this.remRedCheck = true
      // } else {
      //   this.remRedCheck = false
      // }
    }
    this.lastedData = this.adv.funding_data.deposit_paid_to
  },
  methods: {
    /**
       * Sélection d'un notaire du référentiel : lie et remplit les champs
       * @param {object} interlocuteur - { ...interlocuteur, tiers }
       */
    selectNotaireClient (interlocuteur) {
      this.selectedNotaireClient = interlocuteur
      this.applyTiersSelection(this.writeNotaireClient, interlocuteur)
    },
    /**
       * Délier du référentiel : vide aussi les champs (anti-doublon)
       */
    unlinkNotaireClient () {
      this.selectedNotaireClient = null
      this.applyTiersUnlink(this.writeNotaireClient)
    },
    /**
       * writer(key, value) du bloc notaire client — $set d'abord pour rendre
       * réactives les clés absentes du JSON (tiers_id, interlocuteur_id)
       */
    writeNotaireClient (key, value) {
      this.$set(this.adv.notary_details, key, value)
      this.updateNotaryDetails(key, value)
    },
    /**
       * rotateDocument - Gérer la rotation avec sauvegarde automatique
       * @param {object} params - {document, rotation, target}
       */
    rotateDocument ({ document, rotation, target = 'documents' }) {
      // Dans ContratDeReservation, documents est un tableau de {key, name, document}
      if (Array.isArray(this.adv[target])) {
        let idx = this.adv[target].findIndex(x =>
          x.document && (x.document.cloudinary_id === document.cloudinary_id || x.document.fus_id === document.fus_id)
        )
        if (idx >= 0) {
          this.$set(this.adv[target][idx].document, 'rotation', rotation)
          // Sauvegarde automatique comme pour les autres champs du composant
          this.$store.commit('modifyCurrentAdv', { key: target, value: this.adv[target] })
        }
      }
    },
    setPercentageContribution (val) {
      if (!val) {
        this.adv.funding_data.security_deposit_value = null
        this.adv.funding_data.percentage_contribution = null
        this.updateFundingData('percentage_contribution', null)
        this.updateFundingData('security_deposit_value', null)
      } else {
        this.adv.funding_data.percentage_contribution = ((val * 100) / this.adv.sale_price_ttc).toFixed(2)
        this.adv.funding_data.security_deposit_value = val
        this.updateFundingData('security_deposit_value', val)
        this.updateFundingData('percentage_contribution', this.adv.funding_data.percentage_contribution)
      }
    },
    setSecurityDepositValue (val) {
      if (!val) {
        this.adv.funding_data.security_deposit_value = null
        this.adv.funding_data.percentage_contribution = null
        this.updateFundingData('percentage_contribution', null)
        this.updateFundingData('security_deposit_value', null)
      } else {
        this.adv.funding_data.security_deposit_value = ((this.adv.sale_price_ttc * val) / 100).toFixed(2)
        this.adv.funding_data.percentage_contribution = val
        this.updateFundingData('percentage_contribution', val)
        this.updateFundingData('security_deposit_value', this.adv.funding_data.security_deposit_value)
      }
    },
    askRemove (key) {
      this[key] = true
      this.toggleDisplayButtons()
    },
    /**
       * check all fields are not null or empty
       */
    checkFull (obj) { for (var key in obj) { if (obj[key] == null || obj[key] === '') return false } return true },
    /**
       * remove mandatary and update
       */
    async removeMandatary (index) {
      this.adv.mandatary_details.mandataries.splice(index, 1)
      this.updateMandataryDetails('mandataries', this.adv.mandatary_details.mandataries)
    },
    /**
       * add mandatary and update
       */
    async addNewMandatary () {
      this.adv.mandatary_details.mandataries.push({ name: null, company: null, address: null, remuneration: null })
      this.updateMandataryDetails('mandataries', this.adv.mandatary_details.mandataries)
    },
    /**
       * open doc preview
       * @param {object} document
       */
    async openPreview (document) {
      let params = {
        link: document.path
      }
      this.$store.commit('setModal', { mode: 'DOCUMENT_PREVIEW_SAAS', params })
    },
    /**
       * update funding data and commit
       * @param {string} fullKey - funding_data key
       * @param {string} value
       */
    updateFundingData (fullKey, value) {
      let key = `funding_data.${fullKey}`
      this.$store.commit('modifyCurrentAdv', { key, value })
    },
    /**
       * update notary details and commit
       * @param {string} fullKey - notary_details key
       * @param {string} value
       */
    updateNotaryDetails (fullKey, value) {
      if (value === '') value = null
      let key = `notary_details.${fullKey}`
      this.$store.commit('modifyCurrentAdv', { key, value })
    },
    /**
       * update mandatary data and commit
       * @param {string} fullKey - funding_data key
       * @param {string} value
       */
    updateMandataryDetails (fullKey, value) {
      if (value === '') value = null
      let key = `mandatary_details.${fullKey}`
      this.$store.commit('modifyCurrentAdv', { key, value })
    },
    /**
       * update mandatary data and commit
       * @param {string} fullKey - funding_data key
       * @param {string} value
       */
    updateMandataryData (fullKey, value, index) {
      if (value === '') value = null
      this.$store.commit('modifyCurrentAdv', { key: `mandatary_details.mandataries[${index}].${fullKey}`, value })
    },
    /**
       * update mandatary rem data and commit
       * @param {string} fullKey - funding_data key
       * @param {string} value
       */
    updateMandataryRem (value, index) {
      if (value === '') value = null
      let totalRem
      for (var mandatarie of this.adv.mandatary_details.mandataries) {
        if (totalRem == null) {
          totalRem = mandatarie.remuneration
        } else {
          totalRem = totalRem + mandatarie.remuneration
        }
      }
      // if (totalRem > this.adv.seller_remuneration) {
      //   this.remRedCheck = true
      // } else {
      //   this.remRedCheck = false
      // }
      this.$store.commit('modifyCurrentAdv', { key: `mandatary_details.mandataries[${index}].remuneration`, value })
    },
    /**
       * remove contrat document and commit
       * @param {number} idx
       */
    removeContratDocument (idx) {
      this.contratDeReservationDocuments.splice(idx, 1)
      this.$store.commit('modifyCurrentAdv', { key: 'documents', value: this.contratDeReservationDocuments })
    },
    /**
       * add new annex document and commit
       * @param {object} item
       */
    addNewAnnexDocument (item = {}) {
      let newDoc = {
        key: item.key || uuidv4(),
        name: item.name || `Nouveau Document ${this.contratDeReservationDocuments.length + 1}`,
        document: item.document || null
      }
      this.contratDeReservationDocuments.push(newDoc)
      this.$store.commit('modifyCurrentAdv', { key: 'documents', value: this.contratDeReservationDocuments })
    },
    /**
       * get contract url
       */
    async getContractUrl () {
      const request = await this.$api.getReservationContract(this.advPk)
      const win = window.open(request.data, '_blank')
      win.focus()
    },
    async openPreviewContractSelect () {
      let params = {
        source: {
          contracts: this.program.contracts,
          currentContract: this.adv.contract_in_use
        }
      }
      this.$store.commit('setModal', { mode: 'CONTRACT_SELECT_MODAL', params })
    },
    updateValue (value, key, secondaryKey) {
      if (secondaryKey) {
        this.$set(this.adv[key], secondaryKey, value)
      } else {
        this.$set(this.adv, key, value)
      }
    },
    async reloadContract () {
      this.loadContract = true
      try {
        await this.$api.get(this.$resources.REFRESH_CONTRACT(this.adv.pk))
        this.$store.commit('setCurrentAdvContract', { data: null })
        this.loadContract = false
      } catch (err) {
        console.log(err)
        this.loadContract = false
      }
    }
  }
}
</script>
<style lang="sass">
.btn-generate_contract
  width: 50px
.reload-contract
  font-size: 10px
.rectangle-arrondi-712
  border-radius: 10px
  background-color: #5c5c5c

</style>
